import { browserTracingIntegration } from '@sentry/browser';

import { defaultSamplingRate, devOriginList, prodOriginList } from '../config';
import { samplingRate } from '../helper/getConfigFromBackend';
import { environment } from '../helper/getEnvironment';

export const browserTracing = browserTracingIntegration({
    tracingOrigins: environment.isProd ? prodOriginList : devOriginList,
});

export const tracesSampleRate = samplingRate ?? defaultSamplingRate;
